import React, {useMemo} from 'react';
import {Card, CardActions, CardContent, Divider, Typography} from "@mui/material";
import {CardTitle} from "@atttomyx/react-components";
import {arrays} from "@atttomyx/shared-utils";
import {signatureUtils} from "../../utils";
import "./submissionCard.css";

const SubmissionCard = (props) => {
    const {questionnaire, submission, children} = props;
    let n = 0;

    const description = useMemo(() => {
        return arrays.splitOnNewline(questionnaire.description);
    }, [questionnaire.description]);

    return <Card className="submission-card" raised={true}>
        <CardContent>
            <CardTitle>
                {questionnaire.title}
            </CardTitle>
            <Divider/>
            {submission ? submission.questions.map(question =>
                <div key={"question" + n++}>
                    <Typography variant="caption" component="div" className="ask">
                        {question.ask}
                    </Typography>
                    {signatureUtils.isImage(question.reply) ?
                        <img src={question.reply} alt="signature" className="signature"/> :
                        <Typography variant="caption" component="div" className="reply">
                            {question.reply ? question.reply : "-"}
                        </Typography>}
                </div>) :
                <Typography variant="caption" className="description">
                    {description.length > 0 ? description[0] : "Please complete this form"}
                </Typography>}
        </CardContent>
        <CardActions disableSpacing={true}>
            {children}
        </CardActions>
    </Card>
}

export default SubmissionCard;
